import { motion } from "framer-motion";

const REVEAL_INITIAL = { opacity: 0, y: 16 };
const REVEAL_ANIMATE = { opacity: 1, y: 0 };
const REVEAL_VIEWPORT = { once: true, margin: "-50px" };
const REVEAL_DURATION = 0.5;

export function SectionHeader({ overline, title, subtitle, align = "left" }) {
  return (
    <motion.div
      initial={REVEAL_INITIAL}
      whileInView={REVEAL_ANIMATE}
      viewport={REVEAL_VIEWPORT}
      transition={{ duration: REVEAL_DURATION }}
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      {overline && <div className="overline mb-4" data-testid="section-overline">{overline}</div>}
      <h2 className="font-display text-3xl sm:text-4xl font-bold text-[#0F172A] leading-tight">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">{subtitle}</p>
      )}
    </motion.div>
  );
}

export function Reveal({ children, delay = 0 }) {
  return (
    <motion.div
      initial={REVEAL_INITIAL}
      whileInView={REVEAL_ANIMATE}
      viewport={REVEAL_VIEWPORT}
      transition={{ duration: REVEAL_DURATION, delay }}
    >
      {children}
    </motion.div>
  );
}
